import { Fragment, memo } from 'react';
import styled from 'styled-components';
import { GREAT_WHITE } from 'HubStyleTokens/colors';
import SkeletonBox from 'conversations-skeleton-state/components/SkeletonBox';
import { EditorLoadingState } from '../../../editor-utilities/protected/components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TabsSkeleton = styled(SkeletonBox).withConfig({
  displayName: "ReplyEditorLoadingState__TabsSkeleton",
  componentId: "sc-1qyfpu6-0"
})(["border-bottom:1px solid ", ";border-top:1px solid ", ";"], GREAT_WHITE, GREAT_WHITE);
const _ReplyEditorLoadingState = () => /*#__PURE__*/_jsxs(Fragment, {
  children: [/*#__PURE__*/_jsx(TabsSkeleton, {
    height: "49px",
    width: "100%",
    use: "blank"
  }), /*#__PURE__*/_jsx(EditorLoadingState, {})]
});
_ReplyEditorLoadingState.displayName = 'ReplyEditorLoadingState';
export const ReplyEditorLoadingState = /*#__PURE__*/memo(_ReplyEditorLoadingState);